import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout'
import { Injectable } from '@angular/core'
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbAuctionFooterVisibilityService {
  footerVisibility = true

  breakpoint$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall])

  footerVisibilitySubject$ = new BehaviorSubject<boolean>(true)

  footerVisibility$: Observable<boolean> = combineLatest([
    this.breakpoint$,
    this.footerVisibilitySubject$.asObservable(),
  ]).pipe(
    map(([breakpoint, footerVisibility]) => {
      return breakpoint.matches && footerVisibility
    }),
  )

  constructor(private breakpointObserver: BreakpointObserver) {}

  showFooter(): void {
    this.footerVisibilitySubject$.next(true)
  }

  hideFooter(): void {
    this.footerVisibilitySubject$.next(false)
  }
}
